import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { DirectMsgComponent } from '@components/account/direct-msg/direct-msg.component';
import { Invite } from '@models/Core/Invite';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetsPipe } from '@pipes/assets.pipe';
import { ConfigService } from '@services/config.service';

import { ParticipantEntry, participantEntryRole } from '../../../session.util';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'participant-bar',
  templateUrl: './participant-bar.component.html',
  styleUrls: ['./participant-bar.component.scss'],
})
export class ParticipantBarComponent implements OnChanges {
  @Input() entry: ParticipantEntry;
  @Input() session: Session;
  @Output() unInvite = new EventEmitter<Invite>();
  @Output() openIdea = new EventEmitter<Idea>();

  ideas: Idea[];

  constructor(
    private router: Router,
    private config: ConfigService,
    private modal: NgbModal,
    private assetsPipe: AssetsPipe,
  ) {}

  ngOnChanges(changes) {
    if (changes.entry) {
      if (this.entry.type === 'participant') {
        this.ideas = this.session.data.ideas
          .filter(
            idea =>
              (idea.created_by === this.entry.entry._id ||
                idea.collaborators.some(
                  collab => collab.participant_id === this.entry.entry._id,
                )) &&
              idea.published,
          )
          .sort(
            (a, b) =>
              new Date(b.last_changed).getTime() -
              new Date(a.last_changed).getTime(),
          )
          .slice(0, 3);
      } else {
        this.ideas = [];
      }
    }
  }

  ideaThumbnail(idea: Idea) {
    return this.assetsPipe.transform(
      idea.thumbnail_id || 'image/default_idea_thumbnail.png',
    );
  }

  openProfile() {
    if (this.entry.type === 'participant') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/profile/${this.entry.entry.user._id}`]),
      );

      window.open(url, '_blank');
    }
  }

  get isInvite() {
    return this.entry.type === 'invite';
  }

  get canUnInvite() {
    if (this.entry.type === 'invite') {
      const row = this.entry.entry.sessions.find(
        r => r.session.toString() === this.session._id.toString(),
      );
      return this.session.me.role <= row.role;
    } else {
      return false;
    }
  }

  get isModerator() {
    return (
      participantEntryRole(this.entry, this.session) ===
        this.config.roles.SESSION_ADMIN ||
      participantEntryRole(this.entry, this.session) ===
        this.config.roles.SESSION_MODERATOR
    );
  }

  get isParticipant() {
    return (
      participantEntryRole(this.entry, this.session) ===
      this.config.roles.SESSION_PARTICIPANT
    );
  }

  get isExternalEvaluator() {
    return (
      participantEntryRole(this.entry, this.session) ===
      this.config.roles.SESSION_EXTERNAL_EVALUATOR
    );
  }

  directMsg(event) {
    if (this.entry.type === 'participant') {
      event.stopPropagation();
      event.preventDefault();
      const ref = this.modal.open(DirectMsgComponent);
      ref.componentInstance.user = this.entry.entry.user;
    }
  }

  uninvite(event) {
    if (this.entry.type === 'invite') {
      event.stopPropagation();
      event.preventDefault();
      this.unInvite.emit(this.entry.entry);
    }
  }

  ideaClicked(idea, event) {
    event.stopPropagation();
    event.preventDefault();
    this.openIdea.emit(idea);
  }

  num(num: number) {
    if (num < 0) {
      return '---';
    } else if (num < 100) {
      return `${num}`;
    } else {
      return '99+';
    }
  }
}
